import PageContext from "../Context/PageContext";
import { useContext } from "react";

import '@blueprintjs/core/lib/css/blueprint.css';
import { isDesktop, isMobile, isTablet, useMobileOrientation } from "react-device-detect";
import ZoomCard from "./Card/ZoomCard";
import Guide from "./Guide";
import SaveButton from "./SaveButton";
import TextPicker from "./Card/TextPicker";
import ImgController from "./Card/ImgController";
import ShapePicker from "./Card/ShapePicker";
import ElevationColorPicker from "./Card/ElevationColorPicker";
import CadreController from "./Card/CadreController";

export default function EditorBottomMenu() {

    const { selectedItem, objItems } = useContext(PageContext);
    const { isLandscape } = useMobileOrientation();

    var leftTopMenu = <div></div>;
    if (selectedItem != null && selectedItem.classList.value.includes("text-element") && (isMobile && !isTablet)) leftTopMenu = <TextPicker />;
    else if (selectedItem != null && selectedItem.classList.value.includes("image-element") && (isMobile && !isTablet)) leftTopMenu = <ImgController />;
    else if (selectedItem != null && selectedItem.classList.value.includes("cadre-element") && (isMobile && !isTablet)) leftTopMenu = <CadreController />;
    else if (selectedItem != null && selectedItem.classList.value.includes("shape-element") && (isMobile && !isTablet)) leftTopMenu = <ShapePicker />;
    else if (selectedItem != null && selectedItem.classList.value.includes("elevation-element") && (isMobile && !isTablet)) leftTopMenu = <ElevationColorPicker />;

    //recharge quand selectedItem change
    var editorBottomVisible = isCropFirst(selectedItem);

    function isCropFirst(selectedItem: any) {
        if (selectedItem != null && selectedItem.classList.value.includes("cadre-element")) {
            var item = objItems.find(item => item.id === selectedItem.id);
            if (item != null && item.cropCadre != null) return item.cropCadre.isPushImg;
        }
        else return true;

        return true;
    }

    /*2 BLOCK : 1er mobile - second PC
    Block 1 : Sur mobile, on affiche le bloc zoom &co si aucun objet n'est sélectionné
    Block 2 : Sinon on affiche les picker pour personnalisé l'élément */

    return (
        <div className='editor-bottom-menu-container'>

            {isMobile &&
                <div style={{
                    visibility: editorBottomVisible ? "visible" : "hidden"
                }}>
                    { /* Block 1 */
                        <div style={{
                            opacity: (isDesktop || isTablet) || ((isMobile && !isTablet && !isLandscape) && selectedItem != null && selectedItem.id != "mapbox-id") ? "0" : "1",
                            transition: "all .2s",
                            display: (isDesktop || isTablet) || ((isMobile && !isTablet && !isLandscape) && selectedItem != null && selectedItem.id != "mapbox-id") ? "none" : "flex",
                        }}>
                            <div className='editor-bottom-menu-left'>
                                <div>
                                    <Guide></Guide>
                                    <SaveButton></SaveButton>
                                </div>
                            </div>
                            <ZoomCard></ZoomCard>
                        </div>}

                    {/* Block 2 */
                        <div className='editor-bottom-menu-center' style={{
                            opacity: ((isMobile && !isTablet && !isLandscape) && selectedItem == null) || ((isMobile && !isTablet && !isLandscape) && selectedItem != null && selectedItem.id == "mapbox-id") ? "0" : "1",
                            transition: "all .2s",
                            display: ((isMobile && !isTablet && !isLandscape) && selectedItem == null) || ((isMobile && !isTablet && !isLandscape) && selectedItem != null && selectedItem.id == "mapbox-id") ? "node" : "flex"
                        }}>
                            {leftTopMenu}
                        </div>}
                </div>}

            {(isDesktop || isTablet || (isMobile && isLandscape)) &&
                <div style={{
                    visibility: editorBottomVisible ? "visible" : "hidden"
                }}>
                    <div className='editor-bottom-menu left'>
                        <div style={{ display: 'flex' }}>
                            <Guide></Guide>
                        </div>
                    </div>
                    <div className='editor-bottom-menu right-desktop'>
                        <div style={{ display: 'flex' }}>
                            <SaveButton></SaveButton>
                            <ZoomCard></ZoomCard>
                        </div>
                    </div>

                </div>}


        </div>
    );
}

